import { Button } from 'components/Button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from 'components/Dialog';
import { Flex } from 'components/layout';
import ButtonLoader from 'components/loading/ButtonLoader';
import ButtonText from 'types/enums/ButtonText';
import { ButtonNamePosthog } from 'types/enums/CustomPosthogEvents';

// TODO: Generalize to other TMSes
interface MGBCancelLoadDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export default function MGBCancelLoadDialog({
  open,
  onOpenChange,
  onConfirm,
  isLoading,
}: MGBCancelLoadDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <Flex direction='col' gap='sm' className='p-4'>
          <DialogTitle className='text-base'>
            Cancel this load in MercuryGate?
          </DialogTitle>
          <DialogDescription>
            This cannot be undone from Drumkit.
          </DialogDescription>
          <Flex direction='row' gap='sm' className='w-full mt-4' justify='end'>
            <Button
              variant='outline'
              size='sm'
              onClick={() => onOpenChange(false)}
              disabled={!!isLoading}
              buttonNamePosthog={null}
              className='border-neutral-900 text-sm'
            >
              Keep Load
            </Button>
            <Button
              variant='destructive'
              size='sm'
              onClick={onConfirm}
              disabled={!!isLoading}
              buttonNamePosthog={ButtonNamePosthog.CancelMGBLoad}
              className='text-sm'
            >
              {isLoading ? <ButtonLoader /> : ButtonText.CancelLoad}
            </Button>
          </Flex>
        </Flex>
      </DialogContent>
    </Dialog>
  );
}
